import { useState } from "react";
import { FaBars, FaDrum, FaXmark } from "react-icons/fa6";
import { nav } from "../../data/content";
import useScrollSpy from "../../hooks/useScrollSpy";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { activeId, scrolled } = useScrollSpy(nav.map((n) => n.href.replace("#", "")));

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "bg-ink/95 shadow-lg shadow-black/40 backdrop-blur" : "bg-transparent"
      }`}
    >
      <nav className="container flex h-20 items-center justify-between">
        <a href="#accueil" className="flex items-center gap-2 text-white" onClick={() => setOpen(false)}>
          <FaDrum className="text-gold-500" size={22} aria-hidden="true" />
          <span className="font-display text-xl font-bold uppercase tracking-wide sm:text-2xl">
            Sham Dabke
          </span>
        </a>

        <ul className="hidden items-center gap-8 lg:flex">
          {nav.map((item) => {
            const id = item.href.replace("#", "");
            const isActive = activeId === id;
            return (
              <li key={item.href}>
                <a
                  href={item.href}
                  className={`text-sm font-semibold uppercase tracking-wide transition-colors duration-200 ${
                    isActive ? "text-gold-500" : "text-white hover:text-gold-500"
                  }`}
                >
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          aria-expanded={open}
          className="flex h-10 w-10 items-center justify-center rounded-full text-white lg:hidden"
        >
          {open ? <FaXmark size={22} /> : <FaBars size={22} />}
        </button>
      </nav>

      {open && (
        <ul className="flex flex-col gap-1 border-t border-white/10 bg-ink px-6 pb-6 pt-2 lg:hidden">
          {nav.map((item) => {
            const id = item.href.replace("#", "");
            const isActive = activeId === id;
            return (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className={`block py-3 text-sm font-semibold uppercase tracking-wide ${
                    isActive ? "text-gold-500" : "text-white"
                  }`}
                >
                  {item.label}
                </a>
              </li>
            );
          })}
        </ul>
      )}
    </header>
  );
}
